import React from 'react';
import './Logo.css';

const Logo = ({ variant = 'default', size = 'medium' }) => {
  // Logo pour le thème sombre uniquement
  const logoPath = '/img/tsk_main.png';

  // Texte de fallback si le logo n'est pas disponible
  const fallbackText = '⚡ TSK Arena';

  // Gérer l'erreur de chargement du logo
  const [logoError, setLogoError] = React.useState(false);

  const handleError = () => {
    setLogoError(true);
  };

  return (
    <div className={`logo logo-${variant} logo-${size}`}>
      {!logoError ? (
        <img
          src={logoPath}
          alt="TSK Arena Logo"
          className="logo-image"
          onError={handleError}
          key={logoPath}
        />
      ) : (
        <div className="logo-fallback">{fallbackText}</div>
      )}
    </div>
  );
};

export default Logo;
